export const LOAD_SOLUTIONS = 'app/Solutions/LOAD_SOLUTIONS';
export const LOAD_SOLUTIONS_SUCCESS = 'app/Solutions/LOAD_SOLUTIONS_SUCCESS';
export const LOAD_SOLUTIONS_FAILURE = 'app/Solutions/LOAD_SOLUTIONS_FAILURE';

export const LOAD_SOLUTIONS_COUNT = 'app/Solutions/LOAD_SOLUTIONS_COUNT';
export const LOAD_SOLUTIONS_COUNT_SUCCESS =
  'app/Solutions/LOAD_SOLUTIONS_COUNT_SUCCESS';
export const LOAD_SOLUTIONS_COUNT_FAILURE =
  'app/Solutions/LOAD_SOLUTIONS_COUNT_FAILURE';

export const CREATE_SOLUTION = 'app/Solutions/CREATE_SOLUTION';
export const CREATE_SOLUTION_SUCCESS = 'app/Solutions/CREATE_SOLUTION_SUCCESS';
export const CREATE_SOLUTION_FAILURE = 'app/Solutions/CREATE_SOLUTION_FAILURE';

export const IMPORT_SOLUTION = 'app/Solutions/IMPORT_SOLUTION';
export const IMPORT_SOLUTION_SUCCESS = 'app/Solutions/IMPORT_SOLUTION_SUCCESS';
export const IMPORT_SOLUTION_FAILURE = 'app/Solutions/IMPORT_SOLUTION_FAILURE';

export const loadSolutionsSuccess = (solutions) => ({
  type: LOAD_SOLUTIONS_SUCCESS,
  solutions,
});

export const loadSolutionsFailure = (error) => ({
  type: LOAD_SOLUTIONS_FAILURE,
  error,
});

export const loadSolutionsCount = () => ({
  type: LOAD_SOLUTIONS_COUNT,
});

export const loadSolutionsCountSuccess = (counts) => ({
  type: LOAD_SOLUTIONS_COUNT_SUCCESS,
  counts,
});

export const loadSolutionsCountFailure = (error) => ({
  type: LOAD_SOLUTIONS_COUNT_FAILURE,
  error,
});

export const createSolution = (solution) => ({
  type: CREATE_SOLUTION,
  solution,
});

export const createSolutionSuccess = (solution) => ({
  type: CREATE_SOLUTION_SUCCESS,
  solution,
});

export const createSolutionFailure = (error) => ({
  type: CREATE_SOLUTION_FAILURE,
  error,
});

export const importSolution = (code) => ({
  type: IMPORT_SOLUTION,
  code,
});

export const importSolutionSuccess = () => ({
  type: IMPORT_SOLUTION_SUCCESS,
});

export const importSolutionFailure = (error) => ({
  type: IMPORT_SOLUTION_FAILURE,
  error,
});
